import React, {useEffect, useState} from 'react';
import {emptyISearchFilterRequest, INewCategorySearchResultItem, SearchRepository2, TAB_SEARCH_GET_SIZE} from "repositories/SearchRepository2";
import {getHighlightedTextFromHtml} from "../util/commonUtils";
import {getCategoryTypeLangKey} from "../definitions/CategoryType";
import {SsqImages} from "../images/SsqImages";
import {LanguageService} from "../language/LanguageService";
import parse from "html-react-parser";
import {ViewmoreArea} from "../style/CommonStyledComponents";
import TagManager from "react-gtm-module";
import {useHistory} from "react-router-dom";
import {ICategory} from "repositories/category/CategoryRepository";
import clsx from "clsx";
import {ssqutil} from 'util/ssqutil';

interface Props {
  searchRepository: SearchRepository2;
  getTranslatedText: Function;
  languageService: LanguageService;
  searchInput: string;
  setCount: Function;
  isDisplayNextPageButton: boolean;
  srchParam: ISrchParam;
  categoryInitCount: number;
  setProduct: Function;
}

interface ISrchParam {
  resultType: string;
  sortType: string;
  prodType: ICategory;
  periodType: string;
  tagType: [],
  docType: string;
  rangeType: string;
}

export const CategorySearchResultTab2 = (props: Props) => {
  const history = useHistory();

  const [searchPage, setSearchPage] = useState<number>(1);
  const [searchCategoryResult, setSearchCategoryResult] = useState<INewCategorySearchResultItem[]>([]);
  const [categoryCount, setCategoryCount] = useState(props.categoryInitCount);

  useEffect(() => {
    if (searchPage !== 1) {
      props.searchRepository.getNewCategorySearchData(
        {
          ...emptyISearchFilterRequest,
          resultType: props.srchParam.resultType,
          searchKeyword: props.searchInput,
          lang: props.languageService.getLanguage(),
          page: searchPage,
          size: TAB_SEARCH_GET_SIZE,
          daterange: props.srchParam.periodType,
          category: props.srchParam.prodType,
          orderby: props.srchParam.sortType,
          doctype: props.srchParam.docType,
          rangetype: props.srchParam.rangeType,
          tags: props.srchParam.tagType
        }
      ).then(result => {
        setSearchCategoryResult([...searchCategoryResult, ...result.items]);
        setCategoryCount(result.totalCount);
        setSearchPage(searchPage);
      });
    }
  }, [searchPage]);

  useEffect(() => {
    props.searchRepository.getNewCategorySearchData(
      {
        ...emptyISearchFilterRequest,
        resultType: props.srchParam.resultType,
        searchKeyword: props.searchInput,
        lang: props.languageService.getLanguage(),
        page: 1,
        size: TAB_SEARCH_GET_SIZE,
        daterange: props.srchParam.periodType,
        category: props.srchParam.prodType,
        orderby: props.srchParam.sortType,
        doctype: props.srchParam.docType,
        rangetype: props.srchParam.rangeType,
        tags: props.srchParam.tagType
      }
    ).then(result => {
      setSearchCategoryResult(result.items);
      setCategoryCount(result.totalCount);
      setSearchPage(1);
    }).finally(() => {
      props.setProduct('product', true);
    });
  }, [props.searchInput, props.srchParam]);

  useEffect(() => {
    props.setCount('category', categoryCount);
  }, [categoryCount]);

  function getPageCount() {
    return (20 * (searchPage));
  }

  function getTotalCount() {
    return categoryCount;
  }

  return <div className={"category-area"}>
    <div className={"result-title"}>{props.getTranslatedText("I18N_ALL_SEARCH_TAB_CATEGORY")}
      <span>{categoryCount}</span>
    </div>
    {searchCategoryResult.map((item, index) => {
      if (!props.isDisplayNextPageButton && index >= 2) return;
      return <div key={index} className={"result-item"}>
        <div onClick={() => {
          TagManager.dataLayer({
            dataLayer: {
              "event": "search_click",
              "click_search_keyword": props.searchInput,
              "click_title": item.category
            }
          });
        }}>
          <div className={"result-item-tit"}>
            <span className={"category_name tit"} onClick={() => history.push(`/product/category/${item.id}`)}>
                {parse(getHighlightedTextFromHtml(item.name))}
            </span>
          </div>
          <div className={"result-item-info result-item-img-info"}>
            {<div className={clsx("img-wrap", item.discontinue === "true" ? 'sold-out' : '')}>
              <img onClick={() => history.push(`/product/category/${item.id}`)}
                //src={`/uploads/${item.image_blob_key}/category-${item.id}.png`}
                src={ssqutil.getCdnUrl(item.image_blob_key)}
                onError={(e: any) => {
                  e.target.src = SsqImages.common.icon.noImage();
                  e.target.className = "no-image";
                  e.target.alt = "no_image.svg";
                }}/>
            </div>}
            <div className={"txt-wrap"}>
              <div className={"desc-wrap " + ((item.related_models) ? "related-wrap" : "")}>
                <span onClick={() => history.push(`/product/category/${item.id}`)}>
                    {parse(getHighlightedTextFromHtml(item.description))}
                </span>
              </div>
              {(item.related_models) && <div className={"txt_bt"}>
                <div className={"related_bt"}>
                  <span>{props.getTranslatedText("I18N_ALL_SEARCH_MODEL")}</span>
                  <span className={"line"}/>
                  {item.related_models.map((model, index) => {
                    return <span key={index}>
                      <span>{parse(getHighlightedTextFromHtml(model))}</span>
                      {item.related_models.length > index + 1 &&
                        <span className={"comma"}>,</span>}
                    </span>;
                  })}</div>
              </div>}
              <div className={"tit-txt"}>
                <span className={"type"}>{props.getTranslatedText(getCategoryTypeLangKey(item.type_name))}</span>
                <span>{parse(getHighlightedTextFromHtml(item.card_description))}</span>
              </div>
            </div>
          </div>
        </div>
      </div>;
    })}
    {props.isDisplayNextPageButton && categoryCount > (20 * (searchPage)) && <ViewmoreArea>
      <div className={"ViewmoreBtn"}>
        <button className={"view-more-button"}
          onClick={async () => {
            setSearchPage(searchPage + 1);
          }}
        >
          {props.getTranslatedText("I18N_ALL_SEARCH_TAB_VIEW_MORE")}</button>
        <div className={"ViewmoreNum"}>
          <span className={"page-count"}>{getPageCount()}</span>
          <span>{getTotalCount()}</span>
        </div>
      </div>
    </ViewmoreArea>}
  </div>;
};
